export enum UserState {
    registered = '7d3407b9-707e-46b3-9d98-95d3311cd45d',
    confirmed = '9a79d2a9-6f80-40c7-9309-bc99a8e9b9fc',
    incompleteProfile = 'f0cacd82-24b4-4394-8446-1686e503c602',
}
